import React, {Component, Fragment} from 'react'
import {Link, NavLink} from 'react-router-dom'
import Breadcrumb from '../common/breadcrumb';
import Tabset_user from './tabset-user';
import renderHTML from 'react-render-html';
import '../../assets/css/modified.css'
import image6 from "./../../assets/img/icons/dummy.png";
import CourseComplete from "./../../assets/img/icons/course-complete.svg";
import ProjectCompleted from "./../../assets/img/icons/project-completed.svg";
import AssignmentsCompleted from "./../../assets/img/icons/assignments-completed.svg";
import CompletedQuiz from "./../../assets/img/icons/completed-quiz.svg";
import Rising from "./../../assets/img/icons/rising.png";
import Dail from "./../../assets/img/icons/dial.png";


let productNumber={
    product:0
};

export default class userInfo extends Component {


    state = {
        view_mode: 'NULL',
        view_text: 'User Courses',
        active: '',
        userId: null,
        userInfo: {},
        product: [],
        products: [],
        myProducts: [],
        completedCourse: [],
        pendingCourse: [],
        allProduct: [],
        completeCourseId: [],
        completeCourse: 0,
        inprogressCourse: 0,
        myProductsLength: 0
    }

    componentDidMount() {
        if (!localStorage.getItem('userInfo')) {
            window.location.href = '/admin';
        }
        const thePath = window.location.href;
        const userId = thePath.substring(thePath.lastIndexOf('/') + 1)
        this.setState({userId: userId})
        if (userId) {
            // Get all paid and free which is in profile
            fetch(`${process.env['REACT_APP_HOST']}/api/orders/${userId}`)
                .then(
                    (response) => response.json()
                )
                .then(resp => {
                    console.log(resp);
                    // localStorage.setItem('user_Detail', JSON.stringify(resp.userDetail));
                    // var data = resp.orders;
                    // let myProductsLength = 0
                    // data.map((list, index) => {
                    //     list
                    //         .productinfo
                    //         .map((list1, index1) => {
                    //             myProductsLength += 1
                    //         })
                    // })
                    // this.setState({myProducts: data, myProductsLength: myProductsLength});
                });

            // Get all Complete course
            fetch(`${process.env['REACT_APP_HOST']}/api/products/play/${userId}`)
                .then(
                    (response) => response.json()
                )
                .then(data => {
                    console.log("data...")
                    console.log(data)
                    // if (data.error == false) {
                    //     this.setState({ 
                    //         completedCourse: data.completedCourse,
                    //         pendingCourse: data.pendingCourse,
                    //         completeCourse: data.completecount,
                    //         inprogressCourse: data.pendingcount ,
                    //         unComplete: data.unComplete
                    //     },function(){
                           
                    //             this.state.unComplete.map((product, index) => (
                    //                 product.productinfo.map((pro,index1) => (
                    //                     this.setState(prevState => ({
                    //                         allProduct:[...prevState.allProduct ,pro]
                    //                     }))    
                    //                 ))
                    //             ))
                                 
                    //             this.state.completedCourse.map((courseId, index) => (
                    //                 this.setState(prevState => ({
                    //                     completeCourseId:[...prevState.completeCourseId ,courseId._id]
                    //                 }),function(){
                    //                     this.state.completeCourseId.map(
                    //                       x =>  this.state.allProduct.map(
                    //                         (y,z) => {
                                                
                    //                             if(y._id===x){
                    //                                 var aa =  this.state.allProduct
                    //                                 aa.splice(z,1)
                    //                                 this.setState({
                    //                                     allProduct:aa
                    //                                 })
                    //                                 return;
                    //                             }
                    //                         }
                                                    
                    //                     )
                    //                     )
                    //                 })  
                    //             ))
                    //         });
                    // }
                });
        }

    }

    launchCourse = (c_obj) => {
        let user_data = JSON.parse(localStorage.getItem("frontUser"))
        if (user_data) {
            let encode = window.btoa(
                JSON.stringify({token: user_data._id, path: `${process.env['REACT_APP_HOST']}${c_obj.zip}/index.html`})
            )
            window.open(`${process.env['REACT_APP_HOST']}/auth/${encode}`);
        }
    }

    getAllData = () => {
        if (localStorage.getItem('frontUser')) {
            const frontUser = localStorage.getItem('frontUser')
            const obj = JSON.parse(frontUser)
            const userId = obj._id;
            fetch(`${process.env['REACT_APP_HOST']}/api/products/${userId}/sortedProd`)
            // fetch(`${process.env['REACT_APP_HOST']}/api/products`)
                .then((response) => response.json())
                .then(data => {
                    // data.map
                    this.setState({products: data});
                });
        } else {
            fetch(`${process.env['REACT_APP_HOST']}/api/products`)
                .then(
                    (response) => response.json()
                )
                .then(data => {
                    // data.map
                    this.setState({products: data.products});
                });
        }
    }

    showComplete = () => {
        this.setState({view_mode: 'COMPLETED_COURSE', view_text: 'Completed Courses'});
        document
            .getElementById('NULL')
            .classList
            .remove("active");
        document
            .getElementById('COMPLETED_COURSE')
            .classList
            .add("active");
        document
            .getElementById('PENDING_COURSE')
            .classList
            .remove("active");
    }

    showPending = () => {
        this.setState({view_mode: 'PENDING_COURSE', view_text: 'Incomplete Courses'});
        document
            .getElementById('NULL')
            .classList
            .remove("active");
        document
            .getElementById('COMPLETED_COURSE')
            .classList
            .remove("active");
        document
            .getElementById('PENDING_COURSE')
            .classList
            .add("active");
    }

    showCourse = () => {
        this.setState({view_mode: 'NULL', view_text: 'User All Courses'});
        document
            .getElementById('NULL')
            .classList
            .add("active");
        document
            .getElementById('COMPLETED_COURSE')
            .classList
            .remove("active");
        document
            .getElementById('PENDING_COURSE')
            .classList
            .remove("active");
    }

    render() {
        return (
            <> <main className = "pt-3" > <div className="profile_wrapper">
                <div className="container_fluid">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="profile"></div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="mt-0">
                <div className="container_fluid">
                    <h2>User Learning</h2>
                    <hr/>
                    <div className="l-user_overview">

                        {/* Course */}
                        <div className="card c-bg-light-sky" id="NULL" onClick={this.showCourse}>
                            <div className="card-body d-flex align-items-center">
                                <img src={CourseComplete} alt="" width="80px"/>
                                <div className="ms-2">
                                    <h2>{this.state.myProductsLength}</h2>
                                    <h6>Courses</h6>
                                </div>
                            </div>
                        </div>

                        {/* Complete Courses */}
                        <div
                            className="card c-bg-light-sky"
                            id="COMPLETED_COURSE"
                            onClick={this.showComplete}>
                            <div className="card-body d-flex align-items-center">
                                <img src={Dail} alt="" width="80px"/>
                                <div className="ms-2">
                                    <h2>{this.state.completeCourse}</h2>
                                    <h6>Complete Courses</h6>
                                </div>
                            </div>
                        </div>

                        {/* Incomplete Courses */}
                        <div
                            className="card c-bg-light-sky"
                            id="PENDING_COURSE"
                            onClick={this.showPending}>
                            <div className="card-body d-flex align-items-center">
                                <img src={Rising} alt="" width="80px"/>
                                <div className="ms-2">
                                    <h2>{
                                            this.state.myProductsLength - this.state.completeCourse < 0
                                                ? 0
                                                : this.state.myProductsLength - this.state.completeCourse
                                        }</h2>
                                    <h6>Incomplete Courses</h6>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="container_fluid">
                    <section className="m-t-50">
                        <h4>{this.state.view_text}</h4>
                        <hr/> 
                        
                        {/* My Course */}
                        {
                            this.state.view_mode == "NULL"
                                ? <div className="row">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>S.No</th>
                                                                <th>Course Name</th>
                                                                <th
                                                                    className="text-right"
                                                                    style={{
                                                                        paddingRight: '45px'
                                                                    }}>Report</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {
                                                                this.state.myProducts .map((product, index) => (product.productinfo.map((prod, index) => (
                                                                        <tr>
                                                                            <td>#</td>
                                                                            <td>{prod.name}</td>
                                                                            <td className="text-right">
                                                                                <NavLink to={`/report/${prod._id}/${this.state.userId}`}>
                                                                                    <button className="btn btn-md btn-success">Reports</button>
                                                                                </NavLink>
                                                                            </td>
                                                                        </tr>
                                                                    ))))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                : null
                        }

                        {/* COMPLETED_COURSE */}
                        {
                            this.state.view_mode == "COMPLETED_COURSE"
                                ? <div className="row">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>S.No</th>
                                                                <th>Date</th>
                                                                <th
                                                                    className="text-right"
                                                                    style={{
                                                                        paddingRight: '45px'
                                                                    }}>Time</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>

                                                            {
                                                                this
                                                                    .state
                                                                    .completedCourse
                                                                    .map((prod, index) => (
                                                                        <tr>
                                                                            <td>#</td>
                                                                            <td>{prod.name}</td>
                                                                            <td className="text-right">
                                                                                <NavLink to={`/report/${prod._id}/${this.state.userId}`}>
                                                                                    <button className="btn btn-md btn-success">Reports</button>
                                                                                </NavLink>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                            }

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                : null
                        }

                        {/* Incomplete Courses */}
                        {
                            this.state.view_mode == "PENDING_COURSE"
                                ? <div className="row">
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>S.No</th>
                                                                <th>Date</th>
                                                                <th
                                                                    className="text-right"
                                                                    style={{
                                                                        paddingRight: '45px'
                                                                    }}>Time</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>

                                                            {/* {this.state.pendingCourse.map((prod, index) => ( */}
                                                            {this.state.allProduct.map((prod, index) => (
                                                                        <tr>
                                                                            <td>#</td>
                                                                            <td>{prod.name}</td>
                                                                            <td className="text-right">
                                                                                <NavLink to={`/report/${prod._id}/${this.state.userId}`}>
                                                                                    <button className="btn btn-md btn-success">Reports</button>
                                                                                </NavLink>
                                                                            </td>
                                                                        </tr>

                                                                    ))
                                                            }

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                : null
                        }

                        <div className="no-item c-bg-yellow-light p-3 mt-3 d-none">
                            <p className="font_18 t-bold">You currently have no complete projects.</p>
                        </div>
                    </section>
                </div>
            </section>
        </main>
    </>
        )
    }
}
